import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {PlyrComponent} from "ngx-plyr";
import {GeneralService} from "../../services/general/general.service";

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit {
  @Input() audio = '';
  @Input() tracking_id = '';


  // get the component instance to have access to plyr instance
  @ViewChild(PlyrComponent)
  plyr !: PlyrComponent;

// or get it from plyrInit event
  player !: Plyr;

  audioSources: Plyr.Source[] = [];
  audioOptions: Plyr.Options;

  played(event: Plyr.PlyrEvent) {
    console.log('played1', event);
    console.log('1inizio tracciamento',this.tracking_id);

    if(this.tracking_id){
      console.log('2inizio tracciamento',this.tracking_id);
      this.generalService.messaggio_personalizzato_track(this.tracking_id).then((risp)=>{
        console.log('TRACKING MSG',risp);
      },err=>{
        console.error('TRACKING MSG',err);
      });

    }
  }


  constructor(
    private generalService : GeneralService
  ) {
    this.audioOptions = {

      /* autoplay: true,
        muted: true,*/

      controls : [
        'play-large',
        'play',
        'progress',
        'current-time',
       // 'mute',
        //'volume',
        // 'captions',
        //'settings',
        //'pip',
        // 'airplay',
        //'fullscreen'
      ],


    };
    console.log('audioOptions', this.audioOptions);

  }
  ngOnInit(): void {
    this.audioSources = [
      {
        src: this.audio,
        provider: 'html5',
        type :'audio/mp3'
      },
    ]
  }

  play(): void {
    this.player.play(); // or this.plyr.player.play()
  }


  assignPlayer($event: Plyr) {
    this.player = $event
  }
}
